import React, { Fragment } from 'react';
import routes from 'agentRoutes';
import httpClient from 'agentHTTPClient';
import PropTypes from 'prop-types';
import Card from '@welldev-group/rcl-card';
import Button from '@welldev-group/rcl-button';
import Alert from 'sharedWebpack/Alert';
import Amount from 'sharedWebpack/Amount';
import ProductIcon from 'sharedWebpack/ProductIcon';
import ConfirmationModal from 'sharedWebpack/ConfirmationModal';
import ItemMargin from 'sharedWebpack/Margin/ItemMargin';
import TotalMargin from 'sharedWebpack/Margin/TotalMargin';
import ItemWrapper from 'sharedWebpack/ItemWrapper/new';
import { CHANNEL_EBEDS } from 'sharedWebpack/helpers/constants/common';
import SanitizedHTML from 'sharedWebpack/SanitizedHTML';
import classNames from 'classnames';
import CheckoutProgress from '../components/CheckoutProgress';
import CostCenters from '../CostCenters';
import PaymentSidebar from './PaymentSidebar';
import RedemptionVoucher from './Voucher/VoucherContainer';
import ItemDetails from './ItemDetails';
import FeesAndServices from './FeesAndServices/FeesAndServicesContainer';
import history from '../lib/history';
import InstantTicketWrapper from '../../InstantTicketWrapper';
import InstantTicketCard from './InstantTicketCard';
import {
  CASH_FORM_OF_PAYMENT,
  CREDIT_CARD_FORM_OF_PAYMENT,
  NONE_FORM_OF_PAYMENT,
  WALLET_FORM_OF_PAYMENT_CAMELCASE,
} from '../lib/helpers/fop_options';
import { DANGER, SUCCESS, WARNING } from '../lib/helpers/walletConditions';
import ShowGrossTotalPrice from '../../ShowGrossTotalPrice';
import ExchangeHeader from '../Search/flight/Exchange/ExchangeHeader';
import ExchangeProgress from '../Search/flight/Exchange/ExchangeProgress';
import { initialSearchParamsShape } from '../config/shapes';
import AirportShape from '../Search/shapes/AirportShape';
import { PAYMENT_STEP_INDEX } from '../helpers/constants';
import TripSummaryDetails from '../TripSummaryDetails';
import getLocationByAirportCode from '../Cart/helpers/getLocationByAirportCode';
import ChannelListTag from '../helpers/ChannelListTag';
import WELLTRAVEL from '../lib/helpers/welltravel_channel';
import getPaymentAdjustmentTitle from './helpers/getPaymentAdjustmentTitle';
import { fetchAffiliateVerificationStatus } from '../../../admin/Orders/Show/AncillariesTab/SeatMapModal/helpers/api';
import './styles.scss';

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      acknowledgedToInstantTicket: false,
      isModalOpen: false,
      isThreeDsConfirmModalOpen: false,
      isSkipThreeDsConfirmModalOpen: false,
      showLostCardDataAlert: false,
      isFopLoading: false,
      isLoading: false,
      selectedItemId: '',
      welltravelWalletDetails: {},
      isAffiliateVerified: false,
    };
    this.checkoutProgressRef = React.createRef();
  }

  componentDidMount() {
    if (
      this.props.travelers[0] &&
      this.props.travelers[0].id &&
      (this.context.travelerLoggedIn || !this.context.laymanMode) &&
      !this.props.exchange.canExchange
    ) {
      this.props.fetchAccountingTypesForCart(this.context.callbackParams);
    } else if (
      this.props.cartId &&
      (this.context.travelerLoggedIn || !this.context.laymanMode) &&
      !this.props.exchange.canExchange
    ) {
      this.props.fetchCartPeople(this.context.callbackParams);
      this.props.fetchAccountingTypesForCart(this.context.callbackParams);
    }

    if (this.shouldResetPaymentMethod()) {
      this.props.resetFormOfPayment();
    }

    this.fetchWellTravelWallet();
    this.fetchAndSetAffiliateVerificationStatus();
  }

  componentDidUpdate() {
    if (this.props.cartId === null) {
      history.push(`/carts/${this.props.match.params.id}`);
    } else if (this.props.cartId && !this.state.showLostCardDataAlert && !this.state.isFopLoading) {
      let setAlert = false;
      const setFopPromises = [];
      this.props.items.forEach(cartItem => {
        let fopPromise;
        const availableFops = cartItem?.availableFormOfPayment || {};

        const supportedFops = Object.keys(availableFops).filter(
          fop => cartItem.availableFormOfPayment[fop].supported,
        );

        const conditionToReset =
          cartItem.formOfPayment.type === CREDIT_CARD_FORM_OF_PAYMENT &&
          this.props.cardDataAvailableByToken[cartItem.formOfPayment.cardDetails.token] !== true &&
          cartItem.formOfPayment.cardDetails.storedInCcv !== true;

        if (conditionToReset) {
          this.setState({ isFopLoading: true });

          if (this.context.laymanMode) {
            fopPromise = Promise.resolve(this.props.setFormOfPaymentToCash(cartItem.id));
          } else {
            fopPromise = Promise.resolve(this.props.setFormOfPaymentToNone(cartItem.id));
          }

          if (fopPromise) {
            setFopPromises.push(fopPromise);
          }

          setAlert = true;
        }

        if (
          this.props.exchange.canExchange &&
          !cartItem.formOfPayment.type &&
          !this.state.isFopLoading &&
          supportedFops.length === 1
        ) {
          this.setState({ isFopLoading: true });

          const fopActions = {
            [CASH_FORM_OF_PAYMENT]: this.props.setFormOfPaymentToCash,
            [WALLET_FORM_OF_PAYMENT_CAMELCASE]: this.props.setFormOfPaymentToWelltravelWallet,
          };

          const toBeSelectedFop = supportedFops[0];

          fopActions[toBeSelectedFop](cartItem.id).finally(() => {
            this.setState({ isFopLoading: false });
          });
        }
      });

      if (setAlert) {
        Promise.all(setFopPromises).then(() => {
          this.setState({ isFopLoading: false });
        });

        /* eslint-disable-next-line react/no-did-update-set-state */
        this.setState({ showLostCardDataAlert: true });
      }
    }
  }

  people = this.props.travelerCount;
  numberOfAdult = this.people && this.people.adults && this.people.adults.length;
  numberOfChildren = this.people && this.people.children && this.people.children.length;
  numberOfInfant = this.people && this.people.infants && this.people.infants.length;
  totalNumberOfTravelers = this.numberOfAdult + this.numberOfChildren + this.numberOfInfant;

  shouldResetPaymentMethod = () => {
    if (!this.props.cartId) {
      return false;
    }

    if (!this.context.paymentDisabled) {
      return true;
    }

    return this.props.items.some(({ formOfPayment }) => formOfPayment.cardDetails);
  };

  fetchWellTravelWallet = async () => {
    const { cartId } = this.props;
    const { laymanMode } = this.context;

    if (!cartId || laymanMode) {
      return;
    }

    this.setState({ isLoading: true });

    try {
      const { data } = await httpClient.get(routes.api.carts.cartWalletDetails({ cartId }));
      this.setState({ welltravelWalletDetails: data });
    } catch (error) {
      throw error;
    } finally {
      this.setState({ isLoading: false });
    }
  };

  havingAnyInstantTicket = () =>
    this.props.flightResultDetailsById &&
    Object.values(this.props.flightResultDetailsById).some(
      itemDetails => itemDetails.instantTicket,
    );

  triggerCreditCardItemsThreeDs = () => {
    this.setState({ isThreeDsConfirmModalOpen: false });
    this.props.triggerCreditCardItemsThreeDs();
  };

  triggerCreditCardItemsSkipThreeDs = () => {
    this.setState({ isSkipThreeDsConfirmModalOpen: false });
    this.props.skipAuthenticationForAllItems();
  };

  nextStepButtonClicked = () => {
    if (this.havingAnyInstantTicket() && !this.state.acknowledgedToInstantTicket) {
      this.setState({ isModalOpen: true });
    } else if (this.props.exchange.canExchange) {
      history.push(`/orders/${this.props.cartId}/booking`);
    }
  };

  threeDsAuthenticationMessage = haveFailedThreeDsStatuses => {
    if (this.props.threeDsAuthenticationSkipped) {
      return I18n.t('ibe.payment.skip_three_ds_message.authenticate_info');
    } else if (haveFailedThreeDsStatuses) {
      return I18n.t('ibe.payment.three_ds_message.test_failed');
    }

    return I18n.t('ibe.payment.three_ds_message.authenticate_info');
  };

  fopAlertType = haveFailedThreeDsStatuses => {
    if (!haveFailedThreeDsStatuses && !this.props.threeDsAuthenticationSkipped) {
      return 'warning-light';
    } else if (this.props.needToRunThreeDsChecks && haveFailedThreeDsStatuses) {
      return 'danger-light';
    }

    return 'neutral';
  };

  acknowledgedToInstantTicket = () => {
    this.setState({ acknowledgedToInstantTicket: true }, () => {
      if (this.props.exchange?.canExchange) {
        history.push(`/orders/${this.props.cartId}/booking`);
      } else {
        this.checkoutProgressRef.current.moveNextStep();
      }
    });
    this.setState({ isModalOpen: false });
  };

  fetchAndSetAffiliateVerificationStatus = async () => {
    const fetchedStatus = await fetchAffiliateVerificationStatus();
    this.setState({ isAffiliateVerified: fetchedStatus });
  };

  isAllowedInstantTicket = item =>
    item.bookingAttributes &&
    this.props.flightResultDetailsById &&
    this.props.flightResultDetailsById[item.bookingAttributes.resultId] &&
    this.props.flightResultDetailsById[item.bookingAttributes.resultId].instantTicket;

  itemMarginWrapper = item => (
    <ItemMargin
      marginBreakdown={item.marginBreakdown}
      currency={item.currency}
      totalMargin={item.totalMargin}
      iconSize="tiny"
    />
  );

  disableNextButton = () => {
    const {
      items,
      travelers,
      needToRunThreeDsChecks,
      exchange: { canExchange },
    } = { ...this.props };

    if (items.length === 0 || (!canExchange && travelers.length === 0) || needToRunThreeDsChecks) {
      return true;
    }

    const allItemHasFOP = items
      .filter(item => item.hasJourneyElement)
      .every(item => item.formOfPayment && item.formOfPayment.type);

    return !allItemHasFOP;
  };

  isWelltravelChannel = identifier => identifier && identifier.toLowerCase() === WELLTRAVEL;

  channelIdentifier = (identifier, account) => {
    const supplierChannelName = I18n.t(identifier, { scope: 'channels' });

    return this.isWelltravelChannel(identifier)
      ? identifier
      : [supplierChannelName, account].filter(value => value).join(' ');
  };

  exchangeView = () =>
    this.props.initialSearchParams.flights && (
      <div className="d-flex-column row-gap-20">
        <ExchangeHeader
          airports={this.props.airports}
          travelers={this.props.initialSearchParams.flights.travelers}
          trips={this.props.initialSearchParams.flights.trips}
          exchange={this.props.exchange}
        />
        <ExchangeProgress
          activeStepIndex={PAYMENT_STEP_INDEX}
          disableProceedToNextStep={this.disableNextButton()}
          onNextStep={this.nextStepButtonClicked}
          onPrevStep={() => {
            history.push(`/carts/${this.props.cartId}`);
          }}
          hasPaymentError={this.disableNextButton()}
        />
      </div>
    );

  render() {
    const {
      needToRunThreeDsChecks,
      threeDsStatusesByToken,
      ccTokensThatNeedToBook,
      bookingRequestsEncodedByToken,
      threeDsAuthenticationSkipped,
      threeDsAuthenticationMandatory,
      items,
      cartId,
      resetFormOfPayment,
      fetchCart,
      availableFOPsForAll,
      itemsTotal,
      exchange,
      match,
      totalCartItems,
      flightResultDetailsById,
      showCardAddedConfirmation,
      setShowCardAddedConfirmation,
      showTestPassedConfirmation,
      setShowTestPassedConfirmation,
      setQuery,
      setFormOfPaymentForAllItems,
      set3rdPartyPaymentMethod,
      setFormOfPaymentToCash,
      setFormOfPaymentToWelltravelWallet,
      setFormOfPaymentToIATA,
      setFormOfPaymentToNone,
      setFormOfPaymentToCreditCard,
      creditCards,
      configurePaymentGateway,
      paymentGateway,
      maximumNumberOfCardsAdded,
      triggerResetCardAddressForm,
      setTriggerResetCardAddressForm,
      resetCreditCardBillingAddressForm,
      cardDataAvailableByToken,
      affiliatesBillingUrl,
      journeyElements,
      marginTotal,
      airports,
      flightServicesByResultId,
      pastJourneyElement,
      channelsWithQueuesAndRemarks,
      accountingTypes,
      fetchCostCenterOfAccountingType,
      cartCostCenters,
      addCostCenterToCart,
      updateCartCostCenter,
      removeCostCenterFromCart,
      allocationPerAccountingType,
      payableAmount,
    } = this.props;

    const { canExchange } = exchange;
    const isPayable = Number(payableAmount.amount) >= 0;
    const havingAnyInstantTicket = this.havingAnyInstantTicket();
    const nextButtonDisabled = this.disableNextButton();
    const instantTicketAction = havingAnyInstantTicket && !this.state.acknowledgedToInstantTicket;
    const creditCardItemActionNeeded = needToRunThreeDsChecks;
    const threeDsStatusValues = [];
    Object.keys(threeDsStatusesByToken).forEach(uniqueToken => {
      if (ccTokensThatNeedToBook.includes(uniqueToken)) {
        Object.keys(threeDsStatusesByToken[uniqueToken]).forEach(key => {
          if (bookingRequestsEncodedByToken[uniqueToken].includes(key)) {
            threeDsStatusValues.push(threeDsStatusesByToken[uniqueToken][key]);
          }
        });
      }
    });

    const openCreditCardAlertContainer = creditCardItemActionNeeded || threeDsAuthenticationSkipped;

    const haveFailedThreeDsStatuses =
      threeDsStatusValues.length > 0 ? threeDsStatusValues.some(value => value === false) : false;
    const havePassedAllThreeDsStatuses =
      threeDsStatusValues.length > 0 ? threeDsStatusValues.every(value => value === true) : false;

    const itemsNetTotal = items.filter(item => item.hasJourneyElement).map(item => item.netTotal);

    const refreshBalance = async () => {
      this.setState({ isLoading: true });
      this.setState({ isFopLoading: true });

      await resetFormOfPayment().then(() => {
        this.setState({ isFopLoading: false });
      });

      await fetchCart(cartId).then(() => {
        this.setState({ isLoading: false });
      });

      this.fetchWellTravelWallet();
    };

    const walletBalanceForAllItem =
      availableFOPsForAll.welltravelWallet &&
      availableFOPsForAll.welltravelWallet.supported &&
      this.state.welltravelWalletDetails &&
      Number(this.state.welltravelWalletDetails.balance) >= Number(itemsTotal);

    const walletBalanceForSomeItem =
      availableFOPsForAll.welltravelWallet &&
      availableFOPsForAll.welltravelWallet.supported &&
      this.state.welltravelWalletDetails &&
      itemsNetTotal.some(
        netTotal => Number(this.state.welltravelWalletDetails.balance) >= Number(netTotal),
      );

    const walletType = () => {
      if (walletBalanceForAllItem) return SUCCESS;
      else if (walletBalanceForSomeItem) return WARNING;
      return DANGER;
    };

    const { laymanMode } = this.context;

    return (
      <div className="payment-form">
        {canExchange ? (
          this.exchangeView()
        ) : (
          <CheckoutProgress
            cartId={match.params.id}
            nextButtonDisabled={nextButtonDisabled}
            paymentError={nextButtonDisabled}
            nextStepButtonAction={this.nextStepButtonClicked}
            nextStepButtonHasAction={instantTicketAction}
            ref={this.checkoutProgressRef}
            currentStep="payment"
            totalCartItems={totalCartItems}
          />
        )}
        {havingAnyInstantTicket && (
          <div className="payment-form__instant-ticket-confirmation">
            <ConfirmationModal
              className="payment-form__instant-ticket-confirmation--modal"
              isModalOpen={this.state.isModalOpen}
              confirmationHeader={I18n.t('ibe.payment.confirmation_message.instant_ticket.header')}
              subHeader={
                <InstantTicketCard
                  items={items}
                  flightResultDetailsById={flightResultDetailsById}
                />
              }
              confirmationText={I18n.t('ibe.payment.confirmation_message.instant_ticket.agree')}
              rejectionText={I18n.t('ibe.payment.confirmation_message.instant_ticket.not_agree')}
              onConfirm={this.acknowledgedToInstantTicket}
              onReject={() => this.setState({ isModalOpen: false })}
              withAction={true}
              type="warning"
            />
          </div>
        )}
        <div className="payment-form__three-ds-confirmation">
          <ConfirmationModal
            isModalOpen={showCardAddedConfirmation}
            confirmationHeader={I18n.t(
              'ibe.payment.three_ds_message.card_added_confirmation_header',
            )}
            subHeader={I18n.t('ibe.payment.three_ds_message.card_added_sub_header')}
            timeout={3000}
            onTimeout={() => {
              if (showCardAddedConfirmation) {
                setShowCardAddedConfirmation(false);
              }
            }}
            withAction={false}
            type="success"
          />
        </div>
        <div className="payment-form__three-ds-confirmation">
          <ConfirmationModal
            isModalOpen={
              havePassedAllThreeDsStatuses && !needToRunThreeDsChecks && showTestPassedConfirmation
            }
            confirmationHeader={I18n.t('ibe.payment.three_ds_message.test_passed_header')}
            subHeader={I18n.t('ibe.payment.three_ds_message.test_passed')}
            timeout={3000}
            onTimeout={() => {
              if (showTestPassedConfirmation) {
                setShowTestPassedConfirmation(false);
              }
            }}
            withAction={false}
            type="success"
          />
        </div>
        <div
          className={classNames('container container--sm-full-width', {
            'payment__exchange-view': canExchange,
          })}
        >
          <div className="col-lg-4 col-bleed payment__sidebar-wrapper">
            <PaymentSidebar
              setQuery={setQuery}
              callbackParams={this.context.callbackParams}
              setFormOfPaymentForAllItems={setFormOfPaymentForAllItems}
              set3rdPartyPaymentMethod={set3rdPartyPaymentMethod}
              setFormOfPaymentToCash={setFormOfPaymentToCash}
              setFormOfPaymentToWelltravelWallet={setFormOfPaymentToWelltravelWallet}
              setFormOfPaymentToIATA={setFormOfPaymentToIATA}
              setFormOfPaymentToNone={setFormOfPaymentToNone}
              setFormOfPaymentToCreditCard={setFormOfPaymentToCreditCard}
              availableFOPsForAll={availableFOPsForAll}
              welltravelWalletDetails={this.state.welltravelWalletDetails}
              creditCards={creditCards}
              paymentDisabled={this.context.paymentDisabled}
              allowPaymentViaInvoice={this.context.allowPaymentViaInvoice}
              paymentOptions={this.context.paymentOptions}
              configurePaymentGateway={configurePaymentGateway}
              paymentGateway={paymentGateway}
              laymanMode={this.context.laymanMode}
              currency={this.context.currency}
              maximumNumberOfCardsAdded={maximumNumberOfCardsAdded}
              triggerResetCardAddressForm={triggerResetCardAddressForm}
              setTriggerResetCardAddressForm={setTriggerResetCardAddressForm}
              resetCreditCardBillingAddressForm={resetCreditCardBillingAddressForm}
              items={items.filter(item => item.hasJourneyElement)}
              resetFormOfPayment={resetFormOfPayment}
              isFopLoading={this.state.isFopLoading}
              setIsFopLoading={state => this.setState({ isFopLoading: state })}
              selectedItemId={this.state.selectedItemId}
              setSelectedItemId={id => this.setState({ selectedItemId: id })}
              cardDataAvailableByToken={cardDataAvailableByToken}
              walletType={walletType()}
              refreshBalance={refreshBalance}
              isLoading={this.state.isLoading}
              affiliatesBillingUrl={affiliatesBillingUrl}
              canExchange={canExchange}
            />
          </div>
          <div className="col-lg-8 col-bleed payment__item-list-wrapper">
            <Alert
              className="payment-authenticate-alert"
              hideClose={false}
              isVisible={!this.state.isFopLoading && this.state.showLostCardDataAlert}
              onClose={() => this.setState({ showLostCardDataAlert: false })}
              type="warning-light"
            >
              <span>
                {this.context.laymanMode
                  ? I18n.t('ibe.payment.three_ds_message.card_data_lost.invoice')
                  : I18n.t('ibe.payment.three_ds_message.card_data_lost.pay_later')}
              </span>
            </Alert>
            <Alert
              className="payment-authenticate-alert"
              hideClose={true}
              isVisible={havePassedAllThreeDsStatuses && !needToRunThreeDsChecks}
              type="success-light"
            >
              <span>{I18n.t('ibe.payment.three_ds_message.test_passed')}</span>
            </Alert>
            <Alert
              className="payment-authenticate-alert"
              hideClose={true}
              isVisible={openCreditCardAlertContainer}
              type={this.fopAlertType(haveFailedThreeDsStatuses)}
              isIconVisible={true}
            >
              <div className="d-flex align-center justify-between flex-grow column-gap-12">
                <span>{this.threeDsAuthenticationMessage()}</span>
                <Button
                  version="v2"
                  size="small"
                  type="default"
                  label={
                    haveFailedThreeDsStatuses
                      ? I18n.t('ibe.payment.three_ds_message.try_again')
                      : I18n.t('ibe.payment.three_ds_message.authenticate_label')
                  }
                  onClick={() => this.setState({ isThreeDsConfirmModalOpen: true })}
                />
                {this.state.isAffiliateVerified &&
                  !threeDsAuthenticationMandatory &&
                  !threeDsAuthenticationSkipped && (
                    <Button
                      version="v2"
                      size="small"
                      type="default"
                      label={I18n.t('ibe.payment.skip_three_ds_message.button')}
                      onClick={() => this.setState({ isSkipThreeDsConfirmModalOpen: true })}
                    />
                  )}
              </div>
            </Alert>
            <ConfirmationModal
              isModalOpen={this.state.isThreeDsConfirmModalOpen}
              confirmationHeader={I18n.t(
                'ibe.payment.three_ds_message.authenticate_confirmation_header',
              )}
              subHeader={I18n.t('ibe.payment.three_ds_message.authenticate_confirmation_info')}
              confirmationText={I18n.t('ibe.payment.three_ds_message.agree')}
              rejectionText={I18n.t('ibe.payment.three_ds_message.disagree')}
              onConfirm={this.triggerCreditCardItemsThreeDs}
              onReject={() => this.setState({ isThreeDsConfirmModalOpen: false })}
              withAction={true}
              type="warning"
            />
            <ConfirmationModal
              isModalOpen={this.state.isSkipThreeDsConfirmModalOpen}
              confirmationHeader={I18n.t('ibe.payment.skip_three_ds_message.confirmation_header')}
              subHeader={I18n.t('ibe.payment.skip_three_ds_message.confirmation_sub_header')}
              confirmationText={I18n.t('ibe.payment.three_ds_message.agree')}
              rejectionText={I18n.t('ibe.payment.three_ds_message.disagree')}
              onConfirm={this.triggerCreditCardItemsSkipThreeDs}
              onReject={() => this.setState({ isSkipThreeDsConfirmModalOpen: false })}
              withAction={true}
              type="warning"
            />
            <Card className="payment__item-list-wrapper-card">
              <div className="payment-adjustment">
                <div className="payment-adjustment__title">
                  {getPaymentAdjustmentTitle(canExchange, isPayable)}
                </div>
                <div className="payment__margin">
                  <Amount
                    className={classNames(
                      'payment-adjustment__amount',
                      { 'payment-adjustment__amount--payable': canExchange && isPayable },
                      { 'payment-adjustment__amount--refund': canExchange && !isPayable },
                    )}
                    currency={canExchange ? payableAmount.currency : this.context.currency}
                    value={canExchange ? Math.abs(payableAmount.amount) : itemsTotal}
                  />
                  {!laymanMode && !canExchange && (
                    <TotalMargin
                      items={items.filter(item => item.hasJourneyElement)}
                      journeyElements={journeyElements}
                      currency={this.context.currency}
                      marginTotal={marginTotal}
                    />
                  )}
                </div>
              </div>
              <Alert
                className="payment-adjustment__alert"
                hideClose={true}
                isIconVisible={true}
                isVisible={canExchange && !isPayable}
                type="warning-light"
              >
                {I18n.t('ibe.payment.exchange.warning_text')}
              </Alert>
              <RedemptionVoucher />
              {items.map(item => {
                const {
                  id,
                  journeyElementId,
                  journeyElementType,
                  type,
                  currency,
                  grossTotal,
                  formOfPayment,
                  availableFormOfPayment,
                  channel,
                } = item;

                const { identifier, account } = channel;
                const journeyElement = journeyElements.flight[journeyElementId];
                const journeyElementHotel = journeyElements[journeyElementType]?.[journeyElementId];
                const isUnsupportedFopAlertVisible =
                  formOfPayment.type === NONE_FORM_OF_PAYMENT &&
                  !availableFormOfPayment.none.supportedBySupplier &&
                  !canExchange;

                const isEbedsChannel = identifier === CHANNEL_EBEDS;
                const refundable = journeyElementHotel?.refundable;
                const paymentNotSupported = (
                  <SanitizedHTML html={I18n.t('ibe.payment.payment_not_supported_ebeds')} />
                );

                return (
                  <div className="payment__item d-flex-column row-gap-16" key={id}>
                    <div className="payment__item-name d-flex align-center justify-between">
                      <div className="payment__item-name-labels">
                        <ProductIcon
                          productType={journeyElementType || type}
                          showBGColor={true}
                          showLabel={true}
                          size="small"
                        />
                        {this.isAllowedInstantTicket(item) && (
                          <InstantTicketWrapper fop={formOfPayment} size="tiny" />
                        )}
                      </div>
                      {!canExchange && (
                        <div className="d-flex-column row-gap-8">
                          <ShowGrossTotalPrice currency={currency} grossTotal={grossTotal} />
                          {!laymanMode && this.itemMarginWrapper(item)}
                        </div>
                      )}
                    </div>
                    <Alert
                      hideClose={true}
                      isIconVisible={true}
                      isVisible={isUnsupportedFopAlertVisible}
                      type="warning-light"
                    >
                      <span>
                        {isEbedsChannel && !refundable
                          ? paymentNotSupported
                          : I18n.t('ibe.payment.payment_not_supported')}
                      </span>
                    </Alert>
                    {canExchange && journeyElement ? (
                      <Fragment>
                        <TripSummaryDetails
                          trips={journeyElement?.trips}
                          airports={airports}
                          text={I18n.t('components.flight_info.origin_to_destination', {
                            origin: getLocationByAirportCode(airports, journeyElement?.originCode),
                            destination: getLocationByAirportCode(
                              airports,
                              journeyElement?.destinationCode,
                            ),
                          })}
                        />
                        <ItemWrapper
                          item={item}
                          flightServicesByResultId={flightServicesByResultId}
                          showFlightSeatsStatus={true}
                          trips={journeyElement?.trips}
                          journeyElementId={journeyElementId}
                          journeyElementType={journeyElementType}
                          fetchedJourneyElement={journeyElement}
                          laymanMode={laymanMode}
                          canExchange={canExchange}
                          pastJourneyElement={pastJourneyElement}
                        />
                        {!laymanMode && !!identifier && (
                          <div className="d-flex justify-end payment__item-channels payment__item-channels--welltravel-tickets">
                            <ChannelListTag
                              identifier={this.channelIdentifier(identifier, account)}
                              type={this.isWelltravelChannel(identifier) ? 'accent' : null}
                            />
                          </div>
                        )}
                      </Fragment>
                    ) : (
                      <ItemDetails
                        item={item}
                        channelsWithQueuesAndRemarks={channelsWithQueuesAndRemarks}
                        laymanMode={this.context.laymanMode}
                        cardType={paymentGateway && paymentGateway.cardType}
                        paymentDisabled={this.context.paymentDisabled}
                        paymentOptions={this.context.paymentOptions}
                        isFopLoading={this.state.isFopLoading}
                        selectedItemId={this.state.selectedItemId}
                      />
                    )}
                  </div>
                );
              })}
              <FeesAndServices />
            </Card>
          </div>
          {accountingTypes.length > 0 && !canExchange && (
            <React.Fragment>
              <div className="cost-centers-wrapper">
                <CostCenters
                  accountingTypes={accountingTypes}
                  fetchCostCenterOfAccountingType={fetchCostCenterOfAccountingType}
                  usedCostCenters={cartCostCenters}
                  tenantCurrency={this.context.currency}
                  addCostCenterToCart={addCostCenterToCart}
                  updateCartCostCenter={updateCartCostCenter}
                  removeCostCenterFromCart={removeCostCenterFromCart}
                  individualAccountingTypeEnabled={this.context.individualAccountingTypeEnabled}
                  allocationPerAccountingType={allocationPerAccountingType}
                />
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

Payment.contextTypes = {
  currency: PropTypes.string,
  paymentOptions: PropTypes.shape({}),
  paymentDisabled: PropTypes.bool,
  allowPaymentViaInvoice: PropTypes.bool,
  laymanMode: PropTypes.bool.isRequired,
  travelerLoggedIn: PropTypes.bool.isRequired,
  individualAccountingTypeEnabled: PropTypes.bool.isRequired,
  callbackParams: PropTypes.shape({}).isRequired,
};

Payment.defaultProps = {
  itemsTotal: null,
  creditCards: null,
  paymentGateway: null,
  allocationPerAccountingType: [],
  flightResultDetailsById: null,
  cartId: null,
  totalCartItems: 0,
  initialSearchParams: {},
  pastJourneyElement: {},
  payableAmount: {},
};

Payment.propTypes = {
  showCardAddedConfirmation: PropTypes.bool.isRequired,
  setShowCardAddedConfirmation: PropTypes.func.isRequired,
  needToRunThreeDsChecks: PropTypes.bool.isRequired,
  threeDsStatusesByToken: PropTypes.shape({}).isRequired,
  triggerCreditCardItemsThreeDs: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: {
      id: PropTypes.string,
    },
  }).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cardDataAvailableByToken: PropTypes.shape({}).isRequired,
  bookingRequestsEncodedByToken: PropTypes.shape({}).isRequired,
  itemsTotal: PropTypes.string,
  totalCartItems: PropTypes.number,
  channelsWithQueuesAndRemarks: PropTypes.arrayOf(PropTypes.string).isRequired,
  threeDsAuthenticationMandatory: PropTypes.bool.isRequired,
  threeDsAuthenticationSkipped: PropTypes.bool.isRequired,
  skipAuthenticationForAllItems: PropTypes.func.isRequired,
  creditCards: PropTypes.shape({}),
  setFormOfPaymentToCash: PropTypes.func.isRequired,
  setFormOfPaymentToWelltravelWallet: PropTypes.func.isRequired,
  setFormOfPaymentToCreditCard: PropTypes.func.isRequired,
  setFormOfPaymentToIATA: PropTypes.func.isRequired,
  setFormOfPaymentToNone: PropTypes.func.isRequired,
  setFormOfPaymentForAllItems: PropTypes.func.isRequired,
  set3rdPartyPaymentMethod: PropTypes.func.isRequired,
  cartId: PropTypes.string,
  configurePaymentGateway: PropTypes.func.isRequired,
  paymentGateway: PropTypes.shape({
    cardType: PropTypes.string,
  }),
  travelers: PropTypes.arrayOf(PropTypes.shape).isRequired,
  cartCostCenters: PropTypes.arrayOf(PropTypes.shape).isRequired,
  addCostCenterToCart: PropTypes.func.isRequired,
  updateCartCostCenter: PropTypes.func.isRequired,
  fetchAccountingTypesForCart: PropTypes.func.isRequired,
  fetchCostCenterOfAccountingType: PropTypes.func.isRequired,
  removeCostCenterFromCart: PropTypes.func.isRequired,
  fetchCartPeople: PropTypes.func.isRequired,
  accountingTypes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  allocationPerAccountingType: PropTypes.arrayOf(PropTypes.shape),
  flightResultDetailsById: PropTypes.shape({}),
  maximumNumberOfCardsAdded: PropTypes.bool.isRequired,
  ccTokensThatNeedToBook: PropTypes.arrayOf(PropTypes.string).isRequired,
  showTestPassedConfirmation: PropTypes.bool.isRequired,
  setShowTestPassedConfirmation: PropTypes.func.isRequired,
  triggerResetCardAddressForm: PropTypes.bool.isRequired,
  travelerCount: PropTypes.objectOf(
    PropTypes.shape({
      adults: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      infants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }),
  ).isRequired,
  setTriggerResetCardAddressForm: PropTypes.func.isRequired,
  resetCreditCardBillingAddressForm: PropTypes.func.isRequired,
  availableFOPsForAll: PropTypes.shape({
    welltravelWallet: PropTypes.shape({
      supported: PropTypes.bool,
    }),
  }).isRequired,
  resetFormOfPayment: PropTypes.func.isRequired,
  people: PropTypes.shape({
    adults: PropTypes.arrayOf(PropTypes.shape({})),
    children: PropTypes.arrayOf(PropTypes.shape({})),
    infants: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  journeyElements: PropTypes.shape({ flight: PropTypes.shape({}).isRequired }).isRequired,
  setQuery: PropTypes.func.isRequired,
  fetchCart: PropTypes.func.isRequired,
  affiliatesBillingUrl: PropTypes.string.isRequired,
  marginTotal: PropTypes.string.isRequired,
  exchange: PropTypes.shape({
    canExchange: PropTypes.bool,
  }).isRequired,
  initialSearchParams: PropTypes.shape(initialSearchParamsShape),
  airports: AirportShape.isRequired,
  pastJourneyElement: PropTypes.shape({}),
  flightServicesByResultId: PropTypes.shape({ [PropTypes.string]: PropTypes.shape({}) }).isRequired,
  payableAmount: PropTypes.shape({ amount: PropTypes.string, currency: PropTypes.string }),
};

export default Payment;
